import {
  MEM_MAKERS,
  MEM_TAKERS,
  MEM_TRANSFERS,
} from '../actions/types';

let initialState = {
  makers : [],
  takers: [],
  transfers: []
}

export default function(state: Object = initialState, action) {
  switch (action.type) {
    case MEM_MAKERS:
      return {...state, makers: action.payload};
    case MEM_TAKERS:
      return {...state, takers: action.payload};
    case MEM_TRANSFERS:
      return {...state, transfers: action.payload};
    default:
      return state;
  }
}
